import { ActionType, createAction } from 'typesafe-actions'

import { IdIndexedUserGroups, UserGroup, UserGroupData } from './types'

export const fetchAllUserGroupsBegin = createAction('/data/userGroups/ALL_USER_GROUPS_FETCH_BEGIN')

export const fetchAllUserGroupsSuccess = createAction(
  '/data/userGroups/ALL_USER_GROUPS_FETCH_SUCCESS',
  (resolve) => (userGroups: IdIndexedUserGroups) => resolve({ userGroups })
)

export const fetchAllUserGroupsFailure = createAction(
  '/data/userGroups/ALL_USER_GROUPS_FETCH_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const fetchUserGroupBegin = createAction(
  '/data/userGroups/USER_GROUP_FETCH_BEGIN',
  (resolve) => (userGroupId: UserGroup['id']) => resolve({ userGroupId })
)

export const fetchUserGroupSuccess = createAction(
  '/data/userGroups/USER_GROUP_FETCH_SUCCESS',
  (resolve) => (userGroup: UserGroup) => resolve({ userGroup })
)

export const fetchUserGroupFailure = createAction(
  '/data/userGroups/USER_GROUP_FETCH_FAILURE',
  (resolve) => (userGroupId: UserGroup['id'], error: string) => resolve({ userGroupId, error })
)

export const updateUserGroupBegin = createAction(
  '/data/userGroups/USER_GROUP_UPDATE_BEGIN',
  (resolve) => (userGroup: UserGroup) => resolve({ userGroup })
)

export const updateUserGroupSuccess = createAction(
  '/data/userGroups/USER_GROUP_UPDATE_SUCCESS',
  (resolve) => (userGroup: UserGroup) => resolve({ userGroup })
)

export const updateUserGroupFailure = createAction(
  '/data/userGroups/USER_GROUP_UPDATE_FAILURE',
  (resolve) => (error: string) => resolve({ error })
)

export const createUserGroupBegin = createAction(
  '/data/userGroups/USER_GROUP_CREATE_BEGIN',
  (resolve) => (userGroupData: UserGroupData) => resolve({ userGroupData })
)

export const createUserGroupSuccess = createAction(
  '/data/userGroups/USER_GROUP_CREATE_SUCCESS',
  (resolve) => (userGroup: UserGroup) => resolve({ userGroup })
)

export const createUserGroupFailure = createAction(
  '/data/userGroups/USER_GROUP_CREATE_FAILURE',
  (resolve) => (userGroupData: UserGroupData, error: string) => resolve({ userGroupData, error })
)

export const setOneUserGroup = createAction(
  '/data/userGroups/SET_USER_GROUP_SUCCESS',
  (resolve) => (userGroup: UserGroup) => resolve({ userGroup })
)

export type UserGroupAction = ActionType<
  | typeof fetchAllUserGroupsBegin
  | typeof fetchAllUserGroupsSuccess
  | typeof fetchAllUserGroupsFailure
  | typeof updateUserGroupBegin
  | typeof updateUserGroupSuccess
  | typeof updateUserGroupFailure
  | typeof createUserGroupBegin
  | typeof createUserGroupSuccess
  | typeof createUserGroupFailure
  | typeof fetchUserGroupBegin
  | typeof fetchUserGroupSuccess
  | typeof fetchUserGroupFailure
  | typeof setOneUserGroup
>
